/**
 * Two-syllable Korean words component for nickname generation
 * Contains 1000 carefully selected words for creating unique nicknames
 */

export const TWO_SYLLABLE_WORDS = [
  '하늘', '바람', '구름', '노을', '달빛', '별빛', '햇살', '새벽', '봄비', '산들',
  '숲길', '꽃길', '물결', '파도', '바다', '푸름', '해돋', '달밤', '별밤', '눈꽃',
  '꽃샘', '맑음', '향기', '솔밭', '초원', '폭포', '샛별', '강물', '연못', '눈빛',
  '꽃물', '해변', '벚꽃', '낙엽', '은눈', '솔향', '단풍', '노랑', '파랑', '빨강',
  '보라', '분홍', '하양', '연두', '밤별', '별똥', '숲새', '가을', '여름', '겨울',
  '봄날', '산길', '솔잎', '꽃잎', '달샘', '별솔', '달빛', '노래', '미소', '웃음',
  '사랑', '희망', '기쁨', '행복', '온기', '평화', '열정', '빛깔', '향긋', '달콤',
  '상큼', '설레', '토끼', '고래', '기린', '사자', '여우', '수달', '판다', '펭귄',
  '비둘', '갈매', '하마', '호두', '나비', '다람', '참새', '까치', '제비', '고슴',
  '두더', '물개', '해마', '코뿔', '개뿔', '고양', '사과', '포도', '오이', '자두',
  '수박', '참외', '딸기', '라면', '우유', '초코', '김밥', '떡밥', '꿀떡', '당근',
  '배추', '감자', '고구', '비빔', '된장', '두부', '콩밥', '찹쌀', '칡차', '귤향',
  '가방', '연필', '책상', '콤푸', '축제', '소풍', '초대', '우산', '눈썹', '달력',
  '노트', '까로', '마법', '반짝', '별빛', '달빛', '빛솔', '별솔', '꿈길', '꿈결',
  '멜로', '하모', '라온', '다온', '가온', '이든', '도담', '나래', '하람', '하랑',
  '다솜', '마루', '가람', '한울', '미르', '소미', '루나', '세나', '온유', '아라',
  '온기', '단미', '라라', '라임', '라피', '다래', '단비', '고운', '고요', '라라',
  '차차', '반짝', '사뿐', '솔솔', '조용', '풍경', '그림', '가결', '가꽃', '가꿈',
  '가누', '가덕', '가름', '가바', '가밤', '가빛', '가샘', '가순', '가찬', '가춘',
  '가파', '겨결', '겨람', '겨랑', '겨름', '겨맛', '겨물', '겨바', '겨밤', '겨비',
  '겨빛', '겨샘', '겨소', '겨솔', '겨솜', '겨송', '겨순', '겨알', '겨열', '겨움',
  '겨찬', '겨춘', '겨파', '겨향', '구꽃', '구꿈', '구달', '구람', '구바', '구밭',
  '구별', '구봄', '구비', '구빛', '구샘', '구소', '구솔', '구솜', '구송', '구순',
  '구온', '구움', '구잎', '구파', '기결', '기길', '기꿈', '기누', '기달', '기람',
  '기랑', '기루', '기름', '기맛', '기물', '기바', '기밤', '기비', '기빛', '기샘',
  '기송', '기순', '기알', '기열', '기온', '기움', '기잎', '기찬', '기채', '기춘',
  '기향', '꽃꽃', '꽃달', '꽃덕', '꽃름', '꽃맛', '꽃바', '꽃별', '꽃빛', '꽃소',
  '꽃솔', '꽃송', '꽃순', '꽃움', '꽃채', '꽃춘', '꽃파', '꽃향', '꿈꽃', '꿈꿈',
  '꿈누', '꿈달', '꿈랑', '꿈맛', '꿈물', '꿈바', '꿈밤', '꿈별', '꿈봄', '꿈빛',
  '꿈솔', '꿈송', '꿈순', '꿈알', '꿈열', '꿈움', '꿈채', '꿈파', '꿈향', '나결',
  '나길', '나꽃', '나꿈', '나누', '나달', '나덕', '나름', '나맛', '나물', '나밭',
  '나별', '나봄', '나샘', '나솜', '나송', '나순', '나알', '나열', '나온', '나찬',
  '나파', '나향', '노결', '노꽃', '노덕', '노람', '노바', '노밤', '노비', '노빛',
  '노샘', '노솜', '노송', '노순', '노온', '노움', '노춘', '노파', '노향', '누길',
  '누람', '누랑', '누루', '누맛', '누밭', '누별', '누봄', '누비', '누빛', '누소',
  '누솔', '누솜', '누순', '누열', '누채', '누향', '늘길', '늘꿈', '늘누', '늘람',
  '늘물', '늘바', '늘밭', '늘별', '늘비', '늘빛', '늘샘', '늘소', '늘솜', '늘알',
  '늘열', '늘잎', '늘찬', '늘채', '늘파', '늘향', '달누', '달덕', '달맛', '달물',
  '달바', '달밭', '달별', '달봄', '달소', '달솔', '달송', '달순', '달알', '달온',
  '달움', '달찬', '달채', '달파', '달향', '도결', '도꽃', '도꿈', '도누', '도달',
  '도덕', '도람', '도름', '도맛', '도물', '도바', '도비', '도빛', '도소', '도순',
  '도온', '도잎', '도찬', '도채', '도춘', '도향', '라길', '라달', '라덕', '라람',
  '라랑', '라맛', '라물', '라바', '라밤', '라별', '라봄', '라비', '라빛', '라샘',
  '라소', '라솜', '라송', '라열', '라잎', '라찬', '라파', '루누', '루바', '루비',
  '루빛', '루샘', '루소', '루솜', '루송', '루순', '루알', '루온', '루잎', '루찬',
  '루춘', '루파', '루향', '맑결', '맑꽃', '맑람', '맑루', '맑름', '맑맛', '맑물',
  '맑바', '맑밭', '맑봄', '맑비', '맑소', '맑솜', '맑송', '맑순', '맑알', '맑온',
  '맑움', '맑잎', '맑찬', '맑향', '물꿈', '물덕', '물랑', '물맛', '물물', '물바',
  '물별', '물봄', '물빛', '물샘', '물소', '물열', '물잎', '물찬', '물파', '물향',
  '미꽃', '미꿈', '미누', '미덕', '미랑', '미루', '미름', '미바', '미밭', '미봄',
  '미비', '미빛', '미샘', '미솔', '미순', '미열', '미온', '미움', '미채', '미춘',
  '미향', '바결', '바길', '바꽃', '바꿈', '바달', '바랑', '바름', '바맛', '바밤',
  '바비', '바솜', '바순', '바온', '바움', '바찬', '바춘', '바파', '바향', '별꽃',
  '별꿈', '별달', '별덕', '별람', '별랑', '별름', '별맛', '별물', '별바', '별밭',
  '별별', '별봄', '별비', '별샘', '별소', '별송', '별순', '별열', '별온', '별움',
  '별찬', '별채', '별춘', '별향', '보은', '보고', '보덕', '보람', '보랑', '보루',
  '보름', '보양', '보바', '보호', '보별', '보스', '보리', '보다', '보소', '보솜',
  '보송', '보보', '보초', '보라', '몰루', '보온', '봄결', '봄길', '봄꽃', '봄꿈',
  '봄누', '봄달', '봄덕', '봄람', '봄랑', '봄루', '봄름', '봄맛', '봄물', '봄바',
  '봄밭', '봄별', '봄봄', '봄빛', '봄샘', '봄소', '봄송', '봄순', '봄알', '봄열',
  '봄온', '봄잎', '봄채', '봄춘', '봄파', '봄향', '분결', '분랑', '분름', '분바',
  '분밤', '분밭', '분별', '분비', '분샘', '분솔', '분솜', '분송', '분잎', '빛결',
  '빛꽃', '빛꿈', '빛달', '빛람', '빛랑', '빛루', '빛름', '빛물', '빛바', '빛밤',
  '빛별', '빛봄', '빛빛', '빛샘', '빛소', '빛솜', '빛송', '빛순', '빛알', '빛열',
  '빛온', '빛움', '빛잎', '빛찬', '빛파', '빛향', '사결', '사길', '사꽃', '사누',
  '사달', '사람', '사물', '사바', '사밤', '사밭', '사별', '사비', '사샘', '사솔',
  '사솜', '사송', '사순', '사움', '사채', '산꿈', '산누', '산루', '산물', '산밭',
  '산봄', '산빛', '산순', '산알', '산온', '산움', '산잎', '산춘', '산향', '샘결',
  '샘꽃', '샘덕', '샘람', '샘랑', '샘름', '샘맛', '샘물', '샘바', '샘밭', '샘비',
  '샘빛', '샘샘', '샘솜', '샘순', '샘알', '샘온', '샘움', '샘채', '솔길', '솔누',
  '솔달', '솔맛', '솔물', '솔바', '솔밤', '솔별', '솔비', '솔빛', '솔소', '솔솜',
  '솔순', '솔온', '솔찬', '솜결', '솜꽃', '솜누', '솜달', '솜덕', '솜랑', '솜맛',
  '솜물', '솜바', '솜밭', '솜봄', '솜비', '솜빛', '솜샘', '솜소', '솜솔', '솜솜',
  '솜송', '솜순', '솜알', '솜온', '솜움', '솜찬', '솜채', '솜파', '솜향', '숲결',
  '숲꽃', '숲달', '숲람', '숲랑', '숲루', '숲밤', '숲밭', '숲별', '숲비', '숲빛',
  '숲샘', '숲솜', '숲순', '숲알', '숲열', '숲온', '숲찬', '숲채', '숲향', '연길',
  '연꽃', '연꿈', '연누', '연달', '연덕', '연람', '연름', '연물', '연바', '연별',
  '연봄', '연빛', '연샘', '연솔', '연송', '연순', '연알', '연온', '연잎', '연춘',
  '연파', '연향', '온결', '온길', '온덕', '온루', '온맛', '온바', '온별', '온비',
  '온빛', '온샘', '온소', '온송', '온알', '온온', '온움', '온찬', '온춘', '온파',
  '온향', '웃꿈', '웃누', '웃달', '웃람', '웃랑', '웃름', '웃물', '웃바', '웃밤',
  '웃밭', '웃봄', '웃비', '웃소', '웃솔', '웃순', '웃알', '웃열', '웃온', '웃춘',
  '즐결', '즐길', '즐꽃', '즐누', '즐덕', '즐람', '즐랑', '즐물', '즐바', '즐밤',
  '즐밭', '즐봄', '즐비', '즐빛', '즐샘', '즐소', '즐솔', '즐솜', '즐송', '즐순',
  '즐알', '즐열', '즐움', '즐잎', '즐춘', '청길', '청꿈', '청덕', '청람', '청랑',
  '청름', '청바', '청밤', '청비', '청빛', '청샘', '청솜', '청송', '청순', '청열',
  '청온', '청움', '청찬', '청채', '청춘', '청파', '청향', '파꽃', '파꿈', '파달',
  '파덕', '파람', '파름', '파맛', '파밤', '파봄', '파빛', '파소', '파솔', '파솜',
  '파송', '파순', '파움', '파잎', '파찬', '파춘', '파파', '푸결', '푸꿈', '푸달',
  '푸덕', '푸맛', '푸물', '푸밤', '푸별', '푸봄', '푸비', '푸빛', '푸솔', '푸솜',
  '푸순', '푸알', '푸찬', '푸채', '푸파', '푸향', '하결', '하꿈', '하덕', '하름',
  '하밤', '하밭', '하샘', '하송', '하순', '하알', '하열', '하움', '하잎', '하채',
  '하춘', '하파', '하향', '해결', '해꿈', '해달', '해랑', '해름', '해물', '해바',
  '해밤', '해밭', '해별', '해비', '해샘', '해소', '해솜', '해열', '해춘', '해파',
  '해향', '행결', '행꽃', '행꿈', '행덕', '행루', '행바', '행밤', '행봄', '행비',
  '행송', '행순', '행열', '행움', '행잎', '행파', '행향', '향결', '향길', '향꽃',
  '향꿈', '향누', '향달', '향람', '향랑', '향루', '향맛', '향물', '향바', '향밤',
  '향밭', '향별', '향봄', '향비', '향샘', '향솔', '향솜', '향알', '향잎', '향찬',
  '향향', '희결', '희누', '희람', '희랑', '희루', '희름', '희물', '희바', '희봄',
  '희비', '희빛', '희소', '희송', '희온', '희찬', '희채', '희춘', '희파', '희향'
] as const;

/**
 * Generate a random nickname using two words and two digits
 * Format: {word1}{word2}{00-99}
 */
export const generateRandomNickname = (): string => {
  const word1 = TWO_SYLLABLE_WORDS[Math.floor(Math.random() * TWO_SYLLABLE_WORDS.length)];
  const word2 = TWO_SYLLABLE_WORDS[Math.floor(Math.random() * TWO_SYLLABLE_WORDS.length)];
  const digits = Math.floor(Math.random() * 100).toString().padStart(2, '0');
  
  return `${word1}${word2}${digits}`;
};

/**
 * Generate a unique 6-character referral code
 * Uses uppercase letters and numbers, excluding confusing characters (0, O, I, 1)
 */
export const generateReferralCode = (): string => {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // Excluding 0, O, I, 1
  let result = '';
  
  for (let i = 0; i < 6; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  
  return result;
};

/**
 * Validate if a referral code follows the correct format
 */
export const isValidReferralCode = (code: string): boolean => {
  return /^[ABCDEFGHJKLMNPQRSTUVWXYZ23456789]{6}$/.test(code);
};